
<div class="panel">
  <h2>Liste des actions détenues</h2>

  <table *ngIf="entity.ownedShares.length > 0">
    <thead>
      <tr>
        <th>Entité</th>
        <th>Solde</th>
        <th style="width: 50px;"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let share of entity.ownedShares" (click)="showEntity(share)">
        <td name="Entité">{{ share.name }}</td>
        <td name="Solde">
          {{ share.amount }}

          <div class="item-details">
            <ng-container *ngFor="let detail of share.details">
              <div *ngIf="detail.amount !== '0'">
                <label>{{ detail.amount }}</label>
                <span>{{ detail.ownership }} {{ detail.shareType | slmovementlinesharetype:'short' }}</span>
              </div>
            </ng-container>
          </div>
        </td>
        <td style="width: 50px;" class="actions">
          <a class="action-btn">
            <t-icon name="arrow_forward"></t-icon>
          </a>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="empty-table compact" *ngIf="entity.ownedShares.length === 0">
    <p>Aucune action détenue pour cette entité</p>
  </div>

</div>